import { LinkActionLink, LinkAssetLink, LinkExternalLink, LinkInternalLink, LinkThematischerLink } from '../../models';

export const blacklist = [
  {
    tu_bez: 'contact',
    bankCodes: ['47853520', '21750000', '67250020', '20050550', '25050180'],
  },
];

export function getRedirectTimeout(
  link: LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink,
  bankCode: string
): number {
  const isBlacklisted = blacklist.some(
    (item) =>
      link?.__component === 'link.thematischer-link' &&
      link?.description === item.tu_bez &&
      item.bankCodes.includes(bankCode)
  );
  return isBlacklisted ? 0 : 3000;
}
